/**
 * The Basics door — "How to play", and the first-run flow for a new account.
 *
 * ============================ TWO THINGS, ONE SCREEN ===========================
 * The master plan puts Basics on the saloon wall as a door and also makes it what a new
 * account meets first. That is one screen and not two, because the thing a first-run
 * flow has to do — pick a face, be told what the numbers mean, be shown where the way
 * in is — is the same thing a curious player wants from a "how to play" link.
 *
 * The persona picker is the FIRST step, and it is the only step that asks for anything.
 * Everything else is three short paragraphs and a way to the table, because the way to
 * learn this game is to be dealt a hand, and the Learn library (Phase L) is where the
 * actual teaching goes.
 */
import { useNavigate } from "react-router-dom";
import { Link, useParams } from "react-router-dom";
import { PersonaPicker } from "../settings/PersonaPicker";
import "../rooms/rooms.css";

export function Basics() {
  const navigate = useNavigate();
  const { step } = useParams();

  if (step === "persona") {
    return (
      <div className="basics-page">
        <PersonaPicker onDone={() => navigate("/basics")} />
      </div>
    );
  }

  return (
    <div className="basics-page">
      <h1>How to play</h1>
      <p className="muted">
        Five minutes, and then a hand. Nothing here costs anything and nothing here is
        for sale.
      </p>

      <PersonaPicker onDone={() => navigate("/poker/play")} />

      <div className="basics-steps">
        <section className="basics-step">
          <h2>The table calls you "You"</h2>
          <p>
            Your seat is at the bottom with your two cards; everybody else is round the
            rail with a portrait, a name and a stack. A gold ring means it is that
            player's turn. ALL IN means their chips are already in the middle.
          </p>
        </section>
        <section className="basics-step">
          <h2>The numbers are chips, or big blinds</h2>
          <p>
            One tap in Settings switches every number on the screen between the two.
            Stacks are usually talked about in big blinds — "twelve big blinds" is a
            short stack whatever the stakes are.
          </p>
        </section>
        <section className="basics-step">
          <h2>The cards decide before you do</h2>
          <p>
            Every hand is dealt from a seed that was fixed and published as a hash before
            the cards came out, and you can re-deal any hand yourself to check it.{" "}
            <Link to="/fair">How the shuffle works</Link>.
          </p>
        </section>
        <section className="basics-step">
          <h2>When you want to get better</h2>
          <p>
            The Train tab in the poker room drills one decision at a time against solved
            charts, and tells you what a mistake cost. That is the part that is a
            product; the tables are free and stay free.
          </p>
        </section>
      </div>

      <p>
        <Link className="btn" to="/poker/play">Take a seat</Link>
      </p>
    </div>
  );
}
